import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import { useContext } from 'react';
import CmsContext from '../../Context/CmsContext';
import { ManagerPermission, ManagerRole } from '../../Constants/constants';
import { useSelector } from 'react-redux';
import { memoizedGetAuthUser } from '../../Store/Reducer/authReducer';

const sideMenus = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: 'tachometer-alt',
    subMenus: [
      { id: 'home_preview', className: 'sidebar-submenu', label: 'Home Preview', url: '/dashboard/home_preview' },
      { id: 'expires_preview', className: 'sidebar-submenu', label: 'Expires Preview', url: '/dashboard/expire_preview' },
      { id: 'activity_log', className: 'sidebar-submenu', label: 'Activity Log', url: '/dashboard/activity_log' },
    ]
  },
  {
    id: 'template',
    label: 'Template',
    icon: 'th',
    subMenus: [
      { id: 'template_list', className: 'sidebar-submenu', label: 'Template List', url: '/template/list', permission: ManagerPermission.Template },
    ]
  },
  {
    id: 'homepage',
    label: 'Web/App Media',
    icon: 'home',
    subMenus: [
      { id: 'splash_screen', className: 'sidebar-submenu', label: 'Setup App Splash Screen', url: '/cms/splash_screen/list', permission: ManagerPermission.HomeBanner },
      { id: 'top_ribbon', className: 'sidebar-submenu', label: 'Setup Top Ribbon', url: '/cms/top_ribbon/list', permission: ManagerPermission.TopRibbon },
      { id: 'home_banner', className: 'sidebar-submenu', label: 'Setup Banners', url: '/cms/home_banner/list', permission: ManagerPermission.HomeBanner },
      { id: 'shop_by_category', className: 'sidebar-submenu', label: 'Setup Shop by Category', url: '/cms/shop_by_category', permission: ManagerPermission.ShopByCategory },
      { id: 'category_carousel', className: 'sidebar-submenu', label: 'Setup Category Carousel', url: '/cms/category_carousel/list', permission: ManagerPermission.CategoryCarousel },
      { id: 'products_carousel', className: 'sidebar-submenu', label: 'Setup Products Carousel', url: `/cms/products_carousel/list`, permission: ManagerPermission.ProductsCarousel },
      { id: 'brochure', className: 'sidebar-submenu', label: 'Setup Brochures', url: `/cms/brochure/list`, permission: ManagerPermission.Brochure },
      { id: 'brands', className: 'sidebar-submenu', label: 'Setup Brand Carousel', url: '/cms/brand/list', permission: ManagerPermission.Brand },
      { id: 'bottom_banner', className: 'sidebar-submenu', label: 'Setup 1/3 Banners', url: '/cms/bottom_banner/list', permission: ManagerPermission.BottomBanner },
    ]
  }, {
    id: 'category',
    label: 'Category',
    icon: 'apple-alt',
    subMenus: [
      { id: 'category_banner', className: 'sidebar-submenu', label: 'Setup Category Banners', url: '/cms/category_banner/list', permission: ManagerPermission.CategoryBanner },
      { id: 'mega_menu_banner', className: 'sidebar-submenu', label: 'Setup Mega Menu Banners', url: '/cms/mega_menu_banner/list', permission: ManagerPermission.MegaMenuBanner },
      { id: 'category-list', className: 'sidebar-submenu', label: 'Setup Categories', url: '/category/list', permission: ManagerPermission.CategoryBanner },
    ]
  }, {
    id: 'multibuy_setup',
    label: 'Multibuy Setup',
    icon: 'shopping-cart',
    subMenus: [
      { id: 'multibuy_create', className: 'sidebar-submenu', label: 'New MultiBuy', url: '/cms/multibuy/create', permission: ManagerPermission.MultiBuy },
      { id: 'multibuy_list', className: 'sidebar-submenu', label: 'MultiBuy List', url: '/cms/multibuy/list', permission: ManagerPermission.MultiBuy },
    ]
  }, {
    id: 'branches',
    label: 'Branches',
    icon: 'code-branch',
    roles: [ManagerRole.SuperAdmin],
    subMenus: [
      { id: 'branch_create', className: 'sidebar-submenu', label: 'New Branch', url: '/branch/create', permission: ManagerPermission.Branch },
      { id: 'branch_list', className: 'sidebar-submenu', label: 'Branch List', url: '/branch/list', permission: ManagerPermission.Branch },
    ]
  }, {
    id: 'organizations',
    label: 'Organizations',
    icon: 'layer-group',
    roles: [ManagerRole.SuperAdmin],
    subMenus: [
      { id: 'organization_create', className: 'sidebar-submenu', label: 'New Organization', url: '/organization/create', permission: ManagerPermission.Branch },
      { id: 'organization_list', className: 'sidebar-submenu', label: 'Organization List', url: '/organization/list', permission: ManagerPermission.Branch },
    ]
  }, {
    id: 'event',
    label: 'Event',
    icon: 'tags',
    subMenus: [
      { id: 'presell_section_list', className: 'sidebar-submenu', label: 'Presell', url: '/cms/presell_section/list', permission: ManagerPermission.PresellSection },
      { id: 'tradeshow_section_list', className: 'sidebar-submenu', label: 'TradeShow', url: '/cms/tradeshow_section/list', permission: ManagerPermission.TradeShowSection },
    ]
  }, {
    id: 'sponsor',
    label: 'Sponsored Search',
    icon: 'user-friends',
    subMenus: [
      // {id: 'sponsor_create', className: 'sidebar-submenu', label: 'New Sponsor', url: '/cms/sponsor/create', permission: ManagerPermission.SponsorManagement},
      { id: 'sponsor_list', className: 'sidebar-submenu', label: 'Sponsored Search List', url: '/cms/sponsor/list', permission: ManagerPermission.SponsorManagement },
    ]
  }, {
    id: 'user',
    label: 'User Management',
    icon: 'user-friends',
    roles: [ManagerRole.SuperAdmin, ManagerRole.CmsAdmin],
    subMenus: [
      { id: 'manager_create', className: 'sidebar-submenu', label: 'New User', url: '/manager/create', permission: ManagerPermission.UserManagement },
      { id: 'manager_list', className: 'sidebar-submenu', label: 'User List', url: '/manager/list', permission: ManagerPermission.UserManagement },
    ]
  }, {
    id: 'reports',
    label: 'Reports',
    icon: 'chart-bar',
    subMenus: [
      { id: 'missing_images', className: 'sidebar-submenu', label: 'Missing Image Report', url: '/reports/missing_images' },
    ]
  }, {
    id: 'site-config',
    label: 'Site Config',
    icon: 'blog',
    roles: [ManagerRole.SuperAdmin],
    subMenus: [
      { id: 'footer_config', className: 'sidebar-submenu', label: 'Footer Config', url: '/siteconfig/footer', permission: ManagerPermission.SiteConfig },
      { id: 'top_ribbon_config', className: 'sidebar-submenu', label: 'Top Ribbon Config', url: '/siteconfig/top_ribbon', permission: ManagerPermission.SiteConfig },
    ]
  }, {
    id: 'signout',
    label: 'Sign Out',
    icon: 'sign-out-alt',
    url: '/logout',
  }
]

const AdminSidebar = React.memo((props) => {
  const navigate = useNavigate();
  const cmsContext = useContext(CmsContext);
  const { currMainMenu, currSubMenu, setCurrMainMenu, setCurrSubMenu, sidebarCollapsed, setSidebarCollapsed } = cmsContext;
  const authUser = useSelector(memoizedGetAuthUser);

  const onMainMenuClicked = (mainMenu) => {
    if (mainMenu.url) {
      navigate(mainMenu.url);
    } else {
      navigate('/empty');
    }
    setCurrMainMenu(mainMenu);
  }

  const triggerCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  }

  const onSubMenuClick = (subMenu) => {
    if (subMenu.url) {
      setSidebarCollapsed(true);
      navigate(subMenu.url);
    }
    setCurrSubMenu(subMenu);
  }

  const renderSubMenus = () => {
    return currMainMenu?.subMenus?.filter(sm => {
      return authUser && (
        authUser.role == ManagerRole.SuperAdmin ||
        authUser.role == ManagerRole.CmsAdmin ||
        !sm.permission ||
        authUser.permissions.includes(sm.permission?.toString())
      );
    })
      .map((sm, index) => (
        <div
          key={index}
          className={`submenu ${sm.className} ${index > 0 ? 'mt-2' : ''} ${currSubMenu?.id == sm.id ? 'active' : ''}`}
          onClick={(e) => onSubMenuClick(sm)}
        >
          <div className='title'>{sm.label}</div>
        </div>
      ))
  }

  return (
    <>
      <div className='sidebar-toggle'>
        {!sidebarCollapsed && <SVG src="/img/icons/double-arrow-left.svg" width={15} height={15} onClick={triggerCollapse} />}
        {sidebarCollapsed && <SVG src="/img/icons/double-arrow-right.svg" width={15} height={15} onClick={triggerCollapse} />}
      </div>

      <div className={`sidebar d-flex ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <div className='main-menu'>
          {sideMenus.filter(menu => !menu.roles || menu.roles.length == 0 || menu.roles.includes(authUser.role)).map((menu, index) => (
            <div
              key={index}
              className={`one-menu cursor-pointer ${currMainMenu?.id == menu.id ? 'active' : ''}`}
              onClick={e => onMainMenuClicked(menu)}
            >
              <MDBIcon fas icon={menu.icon} />
              <span className='ms-2'>{menu.label}</span>
            </div>
          ))}
        </div>
        <div className='sub-menus'>
          {renderSubMenus()}
        </div>
      </div>
    </>
  )
})

export default AdminSidebar;